import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    state: String
  }

  static targets = ["button"]

  connect() {
    this.updateButtonText()
  }

  toggle() {
    this.stateValue = this.stateValue === "collapsed" ? "expanded" : "collapsed"
    this.element.classList.toggle("collapsed", this.stateValue === "collapsed")
    this.element.classList.toggle("expanded", this.stateValue === "expanded")
    this.updateButtonText()
  }

  updateButtonText() {
    if (!this.hasButtonTarget) return
    this.buttonTarget.textContent = this.stateValue === "collapsed" ? "Show More" : "Show Less"
  }
}
